module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    class: {
      overdue: _vm.isOverdue(_vm.date), duesoon: _vm.dueSoon(_vm.date)
    }
  }, [_vm._v("\n  " + _vm._s(_vm.formatDate(_vm.date)) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b573dd1"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/DueDay.vue
// module id = 556
// module chunks = 1